import VOverlayPreloader from '@/components/ui/loaders/VOverlayPreloader'

export default VOverlayPreloader
